<div class="container" id="main-content" aria-label="Main Content">

    <div class="row" *ngIf="loadIssue">
        <div class="col-md-12">
            <p class="alert-danger" [innerHTML]="'COMMON.LOAD_ISSUE' | translate"> </p>
        </div>
    </div>

    <div *ngIf="!loadIssue">
        <div>
            <h1 tabindex="0" class="heading-title">{{'BOOKING_DETAILS.TITLE' | translate}}</h1>
            <hr />
        </div>

        <div class="row">
            <div class="col-md-8">
                <form [formGroup]="clientForm" autocomplete="off">

                    <div class="card">
                        <div class="card-body">
                            <div class="form-row">
                                <div class="form-group question-form">

                                    <p *ngIf="submitted && !clientForm.valid" class="validation-msg">
                                        {{'FORMS.VALIDATION_MSG' | translate}}</p>

                                    <div class="row">
                                        <label class="input-lbl col-sm-12" id="surname_id">
                                            <span aria-hidden="true"
                                                class="mat-placeholder-required mat-form-field-required-marker">
                                                *</span>
                                            {{'FORMS.SURNAME' | translate}}</label>
                                        <mat-form-field appearance="outline" class="col-sm-7">
                                            <input matInput formControlName="surname" required autocomplete="off"
                                                aria-labelledby="surname_id">
                                        </mat-form-field>
                                        <div *ngIf="submitted && form.surname.errors" class="col-sm-5">
                                            <mat-error
                                                *ngIf='form.surname.errors.required || form.surname.errors.pattern'>
                                                {{'FORMS.SURNAME_IS_REQUIRED' | translate}}
                                            </mat-error>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <label class="input-lbl col-sm-12" id="forenameOne_id">
                                            <span aria-hidden="true"
                                                class="mat-placeholder-required mat-form-field-required-marker">
                                                *</span>
                                            {{'FORMS.FORENAME' | translate}} 1</label>
                                        <mat-form-field appearance="outline" class="col-sm-7">
                                            <input matInput formControlName="forenameOne" required type="search"
                                                aria-labelledby="forenameOne_id">
                                        </mat-form-field>
                                        <div *ngIf="submitted && form.forenameOne.errors" class="col-sm-5">
                                            <mat-error
                                                *ngIf='form.forenameOne.errors.required || form.forenameOne.errors.pattern'>
                                                {{'FORMS.FORENAME_IS_REQUIRED' | translate}}
                                            </mat-error>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <label class="input-lbl col-sm-12"
                                            id="forenameTwo_id">{{'FORMS.FORENAME' | translate}} 2</label>
                                        <mat-form-field appearance="outline" class="col-sm-7">
                                            <input matInput formControlName="forenameTwo" type="search"
                                                aria-labelledby="forenameTwo_id">
                                        </mat-form-field>
                                    </div>

                                    <div class="row">
                                        <label class="input-lbl col-sm-12" id="numberPrefix_id">
                                            <span aria-hidden="true"
                                                class="mat-placeholder-required mat-form-field-required-marker">
                                                *</span>
                                            {{'FORMS.CONTACT_NUMBER_PREFIX' | translate}}</label>
                                        <mat-form-field appearance="outline" class="col-sm-3"
                                            aria-labelledby="numberPrefix_id">
                                            <input matInput ng2TelInput type="search" tabindex="-1" #phoneInput
                                                [ng2TelInputOptions]="{initialCountry: initialCountry, autoPlaceholder: 'aggressive', numberType: 'MOBILE', autoHideDialCode: false, separateDialCode: false }"
                                                formControlName="telephonePrefix"
                                                (countryChange)="countryChange($event)"
                                                (keydown)="disallowPrefixType($event)" required
                                                onkeypress="return false;" onfocus="blur();" />
                                        </mat-form-field>

                                        <label class="input-lbl col-sm-12" id="contactNumber_Id">
                                            <span aria-hidden="true"
                                                class="mat-placeholder-required mat-form-field-required-marker">
                                                *</span>
                                            {{'FORMS.CONTACT_NUMBER' | translate}}</label>
                                        <mat-form-field appearance="outline" class="col-sm-7">
                                            <input matInput type="numeric" id="contactNumber_input" #contactNumber
                                                formControlName="telephone" maxlength="15"
                                                (keyup)="keyPressNumberField($event)" autocomplete="off"
                                                (change)="keyPressNumberField($event)" required onDrag="return false"
                                                onDrop="return false" onPaste="return false"
                                                aria-labelledby="contactNumber_Id" />
                                        </mat-form-field>

                                        <div *ngIf="submitted && form.telephone.errors" class="col-sm-5">
                                            <mat-error *ngIf='form.telephone.errors.required'>
                                                {{'FORMS.CONTACT_NUMBER_IS_REQUIRED' | translate}}
                                            </mat-error>
                                            <mat-error *ngIf='form.telephone.errors.minlength'>
                                                {{'FORMS.CONTACT_NUMBER_IS_REQUIRED' | translate}}
                                            </mat-error>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <label class="input-lbl col-sm-12" id="email_Id">
                                            <span aria-hidden="true"
                                                class="mat-placeholder-required mat-form-field-required-marker">
                                                *</span>
                                            {{'FORMS.EMAIL' | translate}}</label>
                                        <mat-form-field appearance="outline" class="col-sm-7">
                                            <input matInput formControlName="email" required type="search"
                                                aria-labelledby="email_Id">
                                        </mat-form-field>
                                        <div *ngIf="submitted && form.email.errors" class="col-sm-5">
                                            <mat-error *ngIf='form.email.errors.pattern && !form.email.errors.required'>
                                                {{'FORMS.EMAIL_INVALID' | translate}}
                                            </mat-error>
                                            <mat-error *ngIf='form.email.errors.required'>
                                                {{'FORMS.EMAIL_IS_REQUIRED' | translate}}
                                            </mat-error>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <label class="input-lbl col-sm-12" id="confirmEmail_Id">
                                            <span aria-hidden="true"
                                                class="mat-placeholder-required mat-form-field-required-marker">
                                                *</span>
                                            {{'FORMS.CONFIRM_EMAIL' | translate}}</label>
                                        <mat-form-field appearance="outline" class="col-sm-7">
                                            <input matInput formControlName="confirmEmail" required autocomplete="off"
                                                aria-labelledby="confirmEmail_Id">
                                        </mat-form-field>
                                        <div *ngIf="submitted && form.confirmEmail.errors" class="col-sm-5">
                                            <mat-error
                                                *ngIf='form.confirmEmail.errors.pattern && !form.confirmEmail.errors.required'>
                                                {{'FORMS.EMAIL_INVALID' | translate}}
                                            </mat-error>
                                            <mat-error *ngIf="form.confirmEmail.errors.mismatch">
                                                {{'FORMS.EMAIL_MATCH' | translate}}
                                            </mat-error>
                                            <mat-error *ngIf='form.confirmEmail.errors.required'>
                                                {{'FORMS.EMAIL_IS_REQUIRED' | translate}}
                                            </mat-error>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <mat-checkbox formControlName="applicantPresent"
                                            (ngModelChange)="leadBookerChanged($event)" class="col-sm-12">
                                            {{'BOOKING_DETAILS.APPLICANT_PRESENT' | translate}}
                                        </mat-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <div class="col-md-4 mobile-summary">
                <mat-card>
                    <app-booking-summary-card></app-booking-summary-card>
                </mat-card>
            </div>

        </div>
        <div class="row mt-4">
            <div class="col-6">
                <button class="btn btn-primary" (click)="routerGoBack()">{{'COMMON.BACK' | translate}}</button>
            </div>
            <div class="col-6 text-right">
                <button class="btn btn-primary" (click)="proceed()">{{'COMMON.PROCEED' | translate}}</button>
            </div>
        </div>
    </div>
</div>